import React from 'react';
import { darken, readableColor, transparentize } from 'polished';
import styled from 'styled-components';
import SideBarIcon from 'components/atoms/sidebar/SideBarIcon';
import PropTypes from 'prop-types';

const Wrap = styled.div`
    width: 100%;
    max-width: 175px;
    display: flex;
    flex-direction: row;
`;

const SideBarLink = (props) => {
    let className = props.className;
    if (props.isActive) {
        className += ' active';
    }
    if (props.isLogout) {
        className += ' logout';
    }
    const { linkName, isLogOut, icon, clickAction, admin } = props;

    return (
        <div
            onClick={clickAction}
            className={className}
            admin={admin} >
            <Wrap>
                {icon ?
                    <SideBarIcon className={icon}></SideBarIcon> :
                    <div style={{ paddingLeft: '10px' }}></div>}

                {isLogOut ?
                    <span className='linkname'>
                        LOG OUT <br />
                        {linkName}
                    </span> :
                    <span className='linkname'>{linkName}</span>
                }
            </Wrap>
        </div>
    );
};

SideBarLink.propTypes = {
    clickAction: PropTypes.func.isRequired,
    icon: PropTypes.string,
    admin: PropTypes.bool,
    isAccount: PropTypes.bool,
    isActive: PropTypes.bool,
    isInternal: PropTypes.bool,
    linkName: PropTypes.string.isRequired
};

const LinkContainer = styled(SideBarLink)`
    color: ${props => transparentize(0.2, readableColor(props.theme.global.colors.sideBarColor))};
    font-size: 14px;
    padding: 5px 10px 5px 15px;
    text-decoration: none;
    cursor: pointer;
    box-sizing: border-box;
    transition: all 200ms ease-in-out;

    &:hover, &.active{
        color: ${props => props.theme.global.colors.highlightColor}
    }

    &.active{
      background-color: ${props => darken(0.1, props.theme.global.colors.sideBarColor)}
    }

    .linkname {
        text-transform: ${props => (props.textTransform || 'uppercase')};
        line-height: 18px;
    }

    &.logout {
        height: 50px;
    }
}

    @media (max-height: 500px) {
        padding: 5px;
        font-size: 10px;

        .linkname {
            margin-left: -5px;
        }
    }
`;

export default LinkContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/sidebar/SideBarLink.js